export const SET_AUTH_DATA = 'SET_AUTH_DATA';
export const SIGN_OUT = 'SIGN_OUT';
export const REGISTRATION_USER_REQUEST = 'REGISTRATION_USER_REQUEST';
export const SET_ROLES_DATA = 'SET_ROLES_DATA';
export const SET_USER = 'SET_USER';